import { render, staticRenderFns } from "./PersonChange.vue?vue&type=template&id=ae0c4442&scoped=true"
import script from "./PersonChange.vue?vue&type=script&lang=js"
export * from "./PersonChange.vue?vue&type=script&lang=js"
import style0 from "./PersonChange.vue?vue&type=style&index=0&id=ae0c4442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0c4442",
  null
  
)

export default component.exports